import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

import { type DashboardFilters } from "./useLiveDashboardFilters";

export const useLiveOrders = (filters: DashboardFilters) =>
  useQuery({
    queryKey: ["merchandise_live_orders", filters],
    queryFn: async () => await apiClient.getLiveOrdersData({ queries: filters }),
  });
